import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-fiche-heading',
  templateUrl: './fiche-heading.component.html',
  styleUrls: ['./fiche-heading.component.css']
})
export class FicheHeadingComponent implements OnInit {
  @Input()  isArchiveActive: boolean;
  @Input()  isCommitAllowed: boolean;
  @Input()  matTooltipConcern: string;
  @Input()  routeConcern: string;
  @Input()  listingTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
